import React from "react";
import {
  LinksSection,
  LinksSectionGroup,
} from "@components/common/LinksSection";
import { CityFooterFragment } from "../utils/getCityFooterData";
import { getLocationLinks } from "../utils/getLocationLinks";

interface SEOSupplierLinksProps {
  cities: CityFooterFragment[];
}
export const SEOSupplierLinks = ({ cities }: SEOSupplierLinksProps) => {
  const sections: LinksSection[] = [];

  const filteredCities = cities.slice(0, 5);

  for (const city of filteredCities) {
    sections.push({
      title: `More about ${city.name}`,
      links: getLocationLinks(undefined, city, {
        hideDestinations: true,
      }),
    });
  }

  if (!filteredCities[0]) {
    return null;
  }

  return (
    <div className="mt-16">
      <LinksSectionGroup title={`Available Areas`} links={sections} />
    </div>
  );
};
